import log from "loglevel";


log.setLevel("DEBUG");


export default log;
